module.exports = __webpack_public_path__ + "static/wb-shop.330e241b.jpg";